export { default } from './Contact';

require('./contact.scss');